// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsByRange.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import tracker from 'share/tracking/Izenda.Tracker';
import { observable, computed, action } from 'mobx';
import { VALUE_TYPES, DATA_TYPE } from 'logic/data/Izenda.SettingsByRangeConstants';
import { isEmpty, last, clone, isNil, uniq, getOr, find, uniqueId, forEach, defaults, map } from 'lodash/fp';
import ReportPartElementProperties from 'logic/models/Izenda.ReportPartElementProperties';

@tracker
export default class SettingsByRangeItemFieldModel {
  @observable value: string = '';
  @observable fieldId: string = '';
  @observable fieldName: string = '';
  @observable name: string = '';
  @observable querySourceId: string = '';
  @observable functionId: string = '';
  @observable functionName: string = '';
  @observable dataType: string = ''; // current data type (according to current function)

  @observable thresholdFieldElement: {};

  @computed
  get displayName() {
    if (this.functionName) {
      return `${this.functionName} (${this.name})`;
    } else {
      return this.name || null;
    }
  }

  @action
  resetField() {
    this.value = '';
    this.fieldId = '';
    this.fieldName = '';
    this.name = '';
    this.querySourceId = '';
    this.functionId = '';
    this.functionName = '';
    this.dataType = '';
  }

  @action
  populateFieldFromObject(obj) {
    if (!obj) {
      this.resetField();
      return;
    }
    this.value = obj.value;
    this.fieldId = obj.fieldId;
    this.fieldName = obj.fieldName;
    this.name = obj.name;
    this.querySourceId = obj.querySourceId;
    this.functionId = obj.functionId;
    this.functionName = obj.functionName;
    this.dataType = obj.dataType;
  }

  @action
  populateField(
    field: any,
    value: string,
    fieldId: string,
    functionId: string,
    functionName: string,
    querySourceId: string,
    dataType: string
  ) {
    if (!field) {
      this.resetField();
      return;
    }
    this.name = field.name;
    this.value = value;
    this.fieldId = fieldId;
    this.functionId = functionId;
    this.functionName = functionName;
    this.querySourceId = querySourceId;
    this.dataType = dataType;
    this.markDirty();
  }

  /**
   * Update dynamic threshold element
   * @param {object} element
   */
  @action
  updateElement(element: ReportPartElementProperties): void {
    this.thresholdFieldElement = element;
    this.fieldName = getOr('', 'name', element);
  }

  @action
  updateFieldName(fieldName) {
    this.fieldName = fieldName;
    this.markDirty();
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SettingsByRangeItemFieldModel.js